module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_9006.f69ac40f.png";